<template>
  <section class="drug-list">
    <div class="container">
      <h1 class="title is-1 has-text-white drugs__title">{{ title }}</h1>
      <div class="drug__search-container">
        <drug-search
          :currentQuery="filter"
          :resultCount="resultCount"
          @autocomplete-selected="filterSelected"
        ></drug-search>
        <drug-filter @filter-selected="drugTypeFilter"></drug-filter>
      </div>
      <h2 class="title is-2 has-text-grey-light" v-if="displayFeatured">Featured</h2>
      <ul class="drugs__list" v-if="displayFeatured">
        <drug-fact
          v-for="fact in featured"
          :key="fact.id"
          :id="fact.id"
          :filter="filter"
          :featured="true"
        ></drug-fact>
      </ul>
      <ul class="drugs__list" v-if="facts" ref="drugFacts">
        <template v-for="fact in facts">
          <drug-fact
            v-if="fact.meta.type === 'drug_facts.DrugFactPage'"
            :key="fact.id"
            :id="fact.id"
            :filter="filter"
            :type="fact.meta.type"
            :featured="false"
            @loaded="updateCount"
          ></drug-fact>
          <drug-type
            v-if="fact.meta.type === 'drug_facts.DrugTypePage'"
            :key="fact.id"
            :id="fact.id"
            :filter="filter"
            :type="fact.meta.type"
            @loaded="updateCount"
          ></drug-type>
        </template>
      </ul>
    </div>
  </section>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import { sendGaEvent } from '@/utils';
import DrugFact from './DrugFact.vue';
import DrugType from './DrugType.vue';
import DrugSearch from './DrugSearch.vue';
import DrugFilter from './DrugFilter.vue';

export default {
  name: 'drug-list',
  components: {
    DrugFact,
    DrugType,
    DrugSearch,
    DrugFilter,
  },
  props: ['title', 'pageId'],
  data() {
    return {
      facts: [],
      filter: '',
      featured: [],
      resultCount: 0,
    };
  },
  computed: {
    displayFeatured() {
      return this.featured.length > 0 && !this.filter;
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    /**
     * Updates `this.facts` facts.
     */
    getData() {
      axios.get(`${process.env.VUE_APP_API_URL}pages/?descendant_of=${this.pageId}&limit=100&order=title`)
        .then((response) => {
          this.facts = response.data.items;
        })
        .catch((error) => {
          if (error.response.status === 404) {
            this.facts = [];
          }
        });
      axios.get(`${process.env.VUE_APP_API_URL}pages/?type=drug_facts.DrugFactPage&featured=true`)
        .then((response) => {
          this.featured = response.data.items;
        })
        .catch((error) => {
          if (error.response.status === 404) {
            this.featured = [];
          }
        });
    },
    /**
     * Update query when user types in search and update result count
     */
    filterSelected(payload) {
      this.filter = payload;
      this.updateCount();
      if (payload) { // Don't send analytics when we reset with the empty string
        sendGaEvent('Search', 'drugfacts', payload);
      }
    },
    /**
     * change filter when drug type is selected.
     */
    drugTypeFilter(payload) {
      this.filter = payload;
      this.updateCount();
    },
    /**
     * Update results count as drug (types) load in
     */
    updateCount() {
      Vue.nextTick(() => {
        this.resultCount = this.$refs.drugFacts.children.length;
      });
    },
  },
};
</script>
